module.exports = __webpack_public_path__ + "static/media/ui-design-process-flow.02fe6a46.png";